import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: '$accrueRewardsWithCoupons',
  initialState: true,
  reducers: {
    setAccrueRewardsWithCoupons(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setAccrueRewardsWithCoupons } = slice.actions;

export default slice.reducer;
